import React from 'react';
import "./style.css";
import { withRouter } from 'react-router-dom';
import patients from '../../../../../../services/patients/index';
import ToolbarComponent from '../../components/toolbar/index';
import LoadingComponent from '../../../../../../components/loading/index';
import PaginationComponent from '../../components/pagination/index';
import _ from 'lodash'
import AddPatient from '../../components/add-patient/index';

export default withRouter(class PatientsList extends React.Component {
    state = {
        patients: [],
        page: 0,
        numberOfElements: -1,
        loading: true,
        search: "",
        isActive: false
    }

    elementsPerPage = 15

    componentWillMount() {
        patients.count({}, (err,count) => {
            patients.find({}).skip(this.state.page*this.elementsPerPage)
                .limit(this.elementsPerPage).exec((err, patients) => {
                this.setState({loading: false, patients: patients, numberOfElements: count})
            })
        })
    }

    changePage = (page, search = null) => {
        let value = search===null ? this.state.search : search;
        let regex = RegExp(_.lowerCase(value) + "|" + _.capitalize(value) + "|" + _.toUpper(value));
        patients.count({$or: [{name: regex}, {lastname: regex}]}, (err, count) => {
            patients.find({$or: [{name: regex}, {lastname: regex}]}).skip(page*this.elementsPerPage)
                .limit(this.elementsPerPage).exec((err, patients) => {
                this.setState({patients: patients, page: page, search: value, numberOfElements: count});
            })
        })
    }

    onChangeSearch = (e) => {
        let {value} = e.target;
        this.changePage(0,value)
    }

    openPatientDetails = (id) => {
        this.props.history.push(`/registers/details/${id}`)
    }

    renderRow = (patient, index) => {
        return (
            <tr onClick={() => this.openPatientDetails(patient._id)} key={index}>
                <td>{patient._id}</td>
                <td>{patient.name}</td>
                <td>{patient.lastname}</td>
            </tr>
        );
    }

    openModal = () => this.setState({isActive: true})
    closeModal = () => this.setState({isActive: false})

    addPatient = (patient) => {
        this.setState({patients: this.state.patients.concat(patient), isActive: false})
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        return (
            <React.Fragment>
                <ToolbarComponent onChange={this.onChangeSearch} />
                <div className="PatientsList">
                    <div className="card">
                        <div className="card-header">
                            <p className="card-header-title"></p>
                            <a onClick={this.openModal} className="card-header-icon header-button">
                                <span className="icon">
                                    <i className="fas fa-plus" aria-hidden="true"></i>
                                </span>
                            </a>
                        </div>
                        <div className="card-content">
                            <table className="table is-fullwidth is-hoverable">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre</th>
                                        <th>Apellido</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.patients.map(this.renderRow)}
                                </tbody>
                            </table>
                        </div>
                        <div className="card-footer"
                            style={{padding: 10}}>
                            <PaginationComponent numberOfElements={this.state.numberOfElements}
                                elementsPerPage={this.elementsPerPage}
                                currentPage={this.state.page}
                                changePage={this.changePage}
                            />
                        </div>
                    </div>
                </div>
                <AddPatient addPatient={this.addPatient} close={this.closeModal} isActive={this.state.isActive} />
            </React.Fragment>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patients-list/index.js